import { MdFileUpload } from '@fareye/utils'
import React from 'react'
import { useDropzone } from 'react-dropzone'
import styled from 'styled-components'
import { dragColors } from '@fareye/configs'
const getColor = (props: any) => {
  if (props.isDragAccept) {
    return dragColors.isDragAccept
  }
  if (props.isDragReject) {
    return dragColors.isDragReject
  }
  if (props.isDragActive) {
    return dragColors.isDragActive
  }
  return '#eeeeee'
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${props => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
  height: 32px;
  cursor: pointer;
`

type FilePickerProps = {
  title: string
  accept: string
  maxFiles?: number
  onFileUpload?: (input: any) => void
  onError: (error: any) => void
  onFileDrop: (res: any) => void
  buttonStyle?: React.CSSProperties
  containerStyle?: React.CSSProperties
  iconColor?: string
}

const focusedStyle = {
  borderColor: '#2196f3'
}

const acceptStyle = {
  borderColor: '#00e676'
}

const rejectStyle = {
  borderColor: '#ff1744'
}

export function FilePicker({
  title,
  accept,
  maxFiles = 1,
  onFileUpload,
  onError,
  onFileDrop,
  containerStyle = {},
  buttonStyle = {},
  iconColor
}: FilePickerProps) {
  const dropZoneOptions: any = {
    maxFiles,
    onDrop: onFileDrop
  }
  if (accept) {
    dropZoneOptions.accept = accept
  }

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isFocused,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone(dropZoneOptions)

  React.useEffect(() => {
    if (onFileUpload) {
      onFileUpload(acceptedFiles)
    }
  }, [acceptedFiles])

  React.useEffect(() => {
    onError(fileRejections)
  }, [fileRejections])

  const style = React.useMemo(
    () => ({
      ...containerStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isFocused, isDragAccept, isDragReject]
  )

  return (
    <div
      className="container"
      style={{
        display: 'flex',
        justifyContent: 'space-around'
      }}
    >
      <Container {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <div
          style={{
            display: 'flex',
            gap: '1em',
            alignItems: 'center',
            ...buttonStyle
          }}
        >
          <MdFileUpload size={18} color={iconColor || '#ffffff'} /> {title}
        </div>
      </Container>
    </div>
  )
}
